import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import DateWithClear from "Components/UI/Form/DateWithClear";
import dayjs from "dayjs";
import { FormControl, InputLabel, MenuItem } from "@mui/material";
import SelectWithClear from "Components/UI/Form/SelectWithClear";

export default function General({
  formData,
  FORM_MODE,
  handleInputChange,
  accountCharts,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled
            name="Id"
            label="ID"
            value={formData?.Id}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <InputLabel>Konto</InputLabel>
            <SelectWithClear
              name="Account"
              label="Konto"
              disabled={FORM_MODE === "LOCKED"}
              value={formData.AccountId}
              onChange={(e) => handleInputChange("AccountId", e.target.value)}
            >
              {accountCharts.map((option) => (
                <MenuItem key={option.Id} value={option.Id}>
                  {option.AccountNumber}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={FORM_MODE === "LOCKED"}
            name="Amount"
            label="Saldo"
            value={formData?.Amount}
            onChange={(e) => handleInputChange("Amount", e.target.value)}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="Datum"
            value={dayjs(formData.Day)}
            disabled={FORM_MODE === "LOCKED"}
            onChange={(newVal) =>
              handleInputChange("Day", dayjs(newVal).format("YYYY-MM-DD"))
            }
          />
        </Grid>
      </Grid>
    </>
  );
}
